import { create } from "zustand";
import { closeOtherModals, registerModalStore } from "./modal-registry";

/** Key this store is known by in the modal registry. */
const MODAL_NAME = "add-saved-colors-to-collection";

export const useAddSavedColorsToCollectionModalStore = create((set) => ({
  isModalOpen: false,
  getSavedColorsToCollectionUrl: null,
  openModal: (url) => {
    closeOtherModals(MODAL_NAME);

    set({ isModalOpen: true, getSavedColorsToCollectionUrl: url });
  },
  closeModal: () =>
    set({ isModalOpen: false, getSavedColorsToCollectionUrl: null }),
  updateIsModalOpen: (isModalOpen) => set({ isModalOpen }),
}));

registerModalStore(MODAL_NAME, useAddSavedColorsToCollectionModalStore);
